const state = {
  articles: [],
  mftGroupId: 13, // MFT Trust group
  props: {
    limit: 10, // default props
  },
  largestQuerySize: 0,
  defaultProps: [
    {
      key: 'limit',
      label: "Limit",
      helperText: "Select the number of items to view (max 30)",
      type: "text",
      value: 10,
      validation: "required:true|between:1,30",
    }
  ],
  status: "WAITING",
};

export default state;
